export const NAME = 'groupHealthCoverage'

export const GET_GROUPHEALTH_PLANS = 'clientBenefitsGrouphealthGet'
export const POST_GROUPHEALTH_PLANS = 'clientBenefitsGrouphealthPost'
export const GET_DENTAL_PLANS = 'getDentalPlans'
